import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8b02770a")

_pushScopeId("data-v-8b02770a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Programma lavoro")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "container_appuntamenti" }
const _hoisted_5 = { class: "container_selected_day" }
const _hoisted_6 = { class: "selected_day" }
const _hoisted_7 = {
  key: 0,
  class: "no_appuntamenti_container"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "no_appuntamenti" }, "Nessun appuntamento da visualizzare", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "cliente_info" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "address" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadAppuntamenti()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Calendar, {
                    value: $setup.date,
                    "is-expanded": "",
                    attributes: $setup.setAttributes,
                    onDayclick: $setup.dayClicked,
                    class: "calendar_container"
                  }, null, 8, ["value", "attributes", "onDayclick"]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, _toDisplayString($setup.selectedDay && $setup.selectedDay.id ? $setup.dateFormat($setup.selectedDay.id) : $setup.dateFormat($setup.date)), 1),
                    (!$setup.appuntamentiToShow.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_7, [
                          _hoisted_8
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_9, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.appuntamentiToShow, (appuntamento) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "appuntamento",
                              key: appuntamento.customers_id,
                              onClick: ($event: any) => ($setup.openDetailModal(appuntamento))
                            }, [
                              _createVNode("div", _hoisted_10, [
                                _createVNode("div", _hoisted_11, _toDisplayString(appuntamento.projects_name), 1),
                                _createVNode("div", _hoisted_12, _toDisplayString($setup.riferimentoCliente(appuntamento)), 1)
                              ])
                            ], 8, ["onClick"]))
                          }), 128))
                        ]))
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})